import { useEffect } from 'react';

const MetaTags = ({
  title,
  description,
  keywords,
  author,
  image,
  url,
  type = 'website',
}) => {
  useEffect(() => {
    const setMetaTag = (name, content, attr = 'name') => {
      if (!content) return;

      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute(attr, name);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    // Title
    if (title) {
      document.title = title;
      setMetaTag('og:title', title, 'property');
      setMetaTag('twitter:title', title);
    }

    // Description
    const desc = description || 'Learn about our mission, vision, and mosque activities.';
    setMetaTag('description', desc);
    setMetaTag('og:description', desc, 'property');
    setMetaTag('twitter:description', desc);

    // Keywords
    setMetaTag('keywords', keywords);
    
    // Author
    setMetaTag('author', author);

    // Open Graph
    setMetaTag('og:type', type, 'property');
    if (url) setMetaTag('og:url', url, 'property');
    if (image) {
      setMetaTag('og:image', image, 'property');
      setMetaTag('twitter:image', image);
    }

    // Twitter
    setMetaTag('twitter:card', 'summary_large_image');

    // Canonical
    if (url) {
      let canonical = document.querySelector("link[rel='canonical']");
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    }

  }, [title, description, keywords, author, image, url, type]);

  return null;
};

export default MetaTags;
